import types from '../mutation-types';

// Frozen pristine defaults. RESET must read from these — NOT from a mutable
// `defaultState` that doubles as the live state, or reset becomes a no-op
// (the panel would never close after a call ends).
const DEFAULT_CALL = Object.freeze({
  conversationId: null,
  callId: null,
  recordId: null,
  contactName: '',
  phone: '',
  status: null,
  startedAt: null,
});
const DEFAULT_UI_FLAGS = Object.freeze({ isOpen: false, isConnecting: false });
const DEFAULT_INCOMING = Object.freeze({
  recordId: null,
  conversationId: null,
  contactName: '',
  phone: '',
  sdpOffer: null,
});

// Factory so each store instance gets its own fresh, independent state and the
// frozen defaults above are never aliased by the live state.
const state = () => ({
  call: { ...DEFAULT_CALL },
  uiFlags: { ...DEFAULT_UI_FLAGS },
  incoming: { ...DEFAULT_INCOMING },
  isRinging: false,
});

export const getters = {
  getCall: $state => $state.call,
  getUIFlags: $state => $state.uiFlags,
  getIncoming: $state => $state.incoming,
  getIsRinging: $state => $state.isRinging,
};

export const actions = {
  setActiveCall({ commit }, payload) {
    commit(types.SET_WHATSAPP_CALL, payload);
    commit(types.SET_WHATSAPP_CALL_UI_FLAG, {
      isOpen: true,
      isConnecting: true,
    });
  },
  setStatus({ commit }, status) {
    commit(types.SET_WHATSAPP_CALL_STATUS, status);
    if (status === 'active')
      commit(types.SET_WHATSAPP_CALL_UI_FLAG, { isConnecting: false });
  },
  reset({ commit }) {
    commit(types.RESET_WHATSAPP_CALL);
  },
  setIncoming({ commit }, payload) {
    commit(types.SET_WHATSAPP_INCOMING, payload);
    commit(types.SET_WHATSAPP_RINGING, true);
  },
  clearIncoming({ commit }) {
    commit(types.CLEAR_WHATSAPP_INCOMING);
    commit(types.SET_WHATSAPP_RINGING, false);
  },
};

export const mutations = {
  [types.SET_WHATSAPP_CALL]($state, payload) {
    $state.call = { ...$state.call, ...payload };
  },
  [types.SET_WHATSAPP_CALL_STATUS]($state, status) {
    $state.call = { ...$state.call, status };
  },
  [types.SET_WHATSAPP_CALL_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.RESET_WHATSAPP_CALL]($state) {
    $state.call = { ...DEFAULT_CALL };
    $state.uiFlags = { ...DEFAULT_UI_FLAGS };
    $state.incoming = { ...DEFAULT_INCOMING };
    $state.isRinging = false;
  },
  [types.SET_WHATSAPP_INCOMING]($state, payload) {
    $state.incoming = { ...DEFAULT_INCOMING, ...payload };
  },
  [types.CLEAR_WHATSAPP_INCOMING]($state) {
    $state.incoming = { ...DEFAULT_INCOMING };
  },
  [types.SET_WHATSAPP_RINGING]($state, value) {
    $state.isRinging = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
